(function () {
  if (window.__adColourTiles) return;
  window.__adColourTiles = true;

  // 1) Colour tiles: update the label and the WhatsApp link when a colour is chosen
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || t.type !== 'radio') return;
    var fs = t.closest('.ad-colour');
    if (!fs) return;
    var lbl = fs.querySelector('[data-selected-value]');
    if (lbl) lbl.textContent = t.value;
    setTimeout(function () {
      var cur = (fs.id && document.getElementById(fs.id)) || fs;
      var a = cur.querySelector('[data-ad-wa]');
      if (!a) return;
      var msg = 'Assalam o Alaikum! Mujhe is suit ki aur photos chahiye: ' + cur.dataset.waTitle + ' (Colour: ' + t.value + ') ' + window.location.href;
      a.href = 'https://wa.me/' + cur.dataset.waNumber + '?text=' + encodeURIComponent(msg);
    }, 400);
  });

  // 2) Thumbnails: keep the small photo strip in sync with the selected colour
  function syncThumbnails(e) {
    var html = e && e.data && e.data.html;
    if (!html) return;
    var src = html.querySelector('[id^="Slider-Thumbnails"]');
    var dst = document.querySelector('[id^="Slider-Thumbnails"]');
    var gallery = document.querySelector('media-gallery');
    if (!src || !dst || !gallery) return;
    dst.innerHTML = src.innerHTML;
    dst.querySelectorAll('[data-target]').forEach(function (li) {
      var b = li.querySelector('button');
      if (b) {
        b.addEventListener('click', function () {
          gallery.setActiveMedia(li.dataset.target, false);
        });
      }
    });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, syncThumbnails);
  }

  // 3) Safety: the theme looks for the new colour's thumbnail before the strip is refreshed.
  // If it is missing, add a hidden placeholder so the theme does not crash and the
  // Add to cart / Buy it now buttons are re-enabled.
  customElements.whenDefined('media-gallery').then(function () {
    var proto = customElements.get('media-gallery').prototype;
    if (proto.__adPatched) return;
    proto.__adPatched = true;
    var orig = proto.setActiveMedia;
    proto.setActiveMedia = function (id, prepend) {
      try {
        var th = this.querySelector('[id^="Slider-Thumbnails"]');
        if (th && !th.querySelector('[data-target="' + id + '"]')) {
          var li = document.createElement('li');
          li.className = 'thumbnail-list__item slider__slide';
          li.setAttribute('data-target', id);
          li.style.display = 'none';
          li.innerHTML = '<button class="thumbnail" type="button"></button>';
          th.appendChild(li);
        }
      } catch (err) {}
      return orig.call(this, id, prepend);
    };
  });
})();